import en_US from './en_US.json';
import pt_BR from './pt_BR.json';

export default { en_US, pt_BR };
